import { csvEscape, csvEscapeRaw } from './csvSafe';
import { DateFormat } from './DateFormat';
import { expenseTypeLabel } from './expenseTypes';

export type ExpenseCsvItem = {
  expense_date?: string | null;
  expense_type?: string;
  amount: number;
  note?: string | null;
};

function asDate(dateStr: string | null | undefined): string {
  if (!dateStr) return '';
  const d = DateFormat(String(dateStr), 'dot');
  return `="${d}"`;
}

function asDecimal(value: number | string | null | undefined): string {
  if (value == null || value === '') return '';
  const n = Number(value);
  if (!Number.isFinite(n)) return '';
  return String(n).replace('.', ',');
}

export function downloadExpensesCsv(
  items: ExpenseCsvItem[],
  filenameBase = 'expenses',
  options?: { includeNote?: boolean }
): void {
  const includeNote = Boolean(options?.includeNote);
  const header = includeNote
    ? ['Дата', 'Тип', 'Описание', 'Сумма']
    : ['Дата', 'Тип', 'Сумма'];
  const lines = [
    header.join(';'),
    ...items.map((item) => {
      const cells = [
        csvEscapeRaw(asDate(item.expense_date)),
        csvEscape(expenseTypeLabel(item.expense_type || '')),
      ];
      if (includeNote) {
        cells.push(csvEscape((item.note || '').trim()));
      }
      cells.push(csvEscapeRaw(asDecimal(item.amount)));
      return cells.join(';');
    }),
  ];
  const blob = new Blob([`\uFEFF${lines.join('\r\n')}\r\n`], {
    type: 'text/csv;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filenameBase}-${new Date().toISOString().slice(0, 10)}.csv`;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
